import type { ColumnFilter } from '@tanstack/react-table';

/** Convert Tanstack Table ColumnFilter[] to Tanstack Router search params */
const filtersToParams = <T extends Record<string, unknown>>(
  filters: ColumnFilter[],
  defaultParams: T
) => {
  return Object.assign(
    defaultParams,
    Object.fromEntries(filters.map(({ id, value }) => [id, value || undefined]))
  );
};

/** Convert Tanstack Router search params to Tanstack Table ColumnFilter[] */
const paramsToFilters = <T extends Record<string, unknown>>(params: T) => {
  return Object.entries(params).reduce((acc, [id, value]) => {
    if (Array.isArray(value) && value.length === 0) {
      return acc;
    }

    if (value) {
      return [...acc, { id, value }];
    }
    return acc;
  }, [] as ColumnFilter[]);
};

/** Helper methods for working with Tanstack Table */
export const tableHelpers = {
  filtersToParams,
  paramsToFilters,
};
